import { render, staticRenderFns } from "./Reporte-fajillas-dashboard.vue?vue&type=template&id=0336e1ce&scoped=true&"
import script from "./Reporte-fajillas-dashboard.vue?vue&type=script&lang=js&"
export * from "./Reporte-fajillas-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Reporte-fajillas-dashboard.vue?vue&type=style&index=0&id=0336e1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336e1ce",
  null
  
)

export default component.exports